import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React from 'react';
import { CsvUploadType } from '../../../../../types/csvUploadConfiguration';
import CsvUploadConfigurationsScreen from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import { Routes, Route, useNavigate } from 'react-router-dom';
import CsvUploadConfigurationUpdatePane from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import ProductExportConfigurationSettingsPane from './Export/ProductExportConfigurationSettingsPane';
import { translate } from '../../../../../types/translation/Translator';
import CreateProductExportConfigurationPane from './Export/Panes/CreateProductExportConfigurationPane';
import UpdateProductExportConfigurationPane from './Export/Panes/UpdateProductExportConfigurationPane';
import { Routing } from '../../../../../util/routes.util';
import { Tab, Tabs } from '../../../../components/Tabs';
import { Breadcrumbs, ProductOverviewCrumb, ProductSettingsCrumb } from '../../../../components/Breadcrumbs';
import ProductTableSettingsPane from './TableSettings/ProductTableSettingsPane';

export default function ProductSettingsScreen() {
  const navigate = useNavigate();

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <ProductOverviewCrumb />
        <ProductSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            text={translate({ key: TranslationKey.importConfigurations })}
            path={Routing.stock.products.settings.importConfigurations.overview()}
            key={'import_configurations'}
          />
          <Tab
            text={translate({ key: TranslationKey.reporting })}
            path={Routing.stock.products.settings.report.overview()}
            key={'report'}
          />
          <Tab
            text={translate({ key: TranslationKey.tableSettings })}
            path={Routing.stock.products.settings.tableSettings.overview()}
            key={'table_settings'}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route
              path='import_configurations/*'
              element={<CsvUploadConfigurationsScreen type={CsvUploadType.product} backPath='/stock/products' />}
            />
            <Route
              path='import_configurations/update/:id/*'
              element={
                <CsvUploadConfigurationUpdatePane
                  type={CsvUploadType.product}
                  onDone={() => navigate(Routing.stock.products.settings.overview())}
                />
              }
            />

            <Route path='table_settings/*' element={<ProductTableSettingsPane />} />

            <Route path='report/*' element={<ProductExportConfigurationSettingsPane />} />
            <Route path='report/create' element={<CreateProductExportConfigurationPane />} />
            <Route path='report/update/:id' element={<UpdateProductExportConfigurationPane />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
